import type { DraftPermitStatementFields } from '@src/permits/completePermit/fields/DraftPermitStatementFields';
import { PermitApplicationClient } from '@src/permits/services/PermitApplicationClient';
import { useMutation } from '@tanstack/react-query';

interface Props {
  permitApplicationId: string;
  onSuccess: () => void;
  onError: () => void;
}

export const useSaveApplicationStatement = ({
  permitApplicationId,
  onSuccess,
  onError,
}: Props) => {
  const { mutate: saveApplicationStatement } = useMutation({
    mutationFn: async (draftCompletePermitForm: DraftPermitStatementFields) => {
      await PermitApplicationClient.updateStatement({
        permitApplicationId,
        fields: draftCompletePermitForm,
      });
    },
    onSuccess,
    onError,
  });

  return { saveApplicationStatement };
};
